export const GLOBAL_SETTINGS = {
  minLengthToTriggerSearch: 3,
  timeZoneKey: 'timeZone',
  dataWarehouseStatus: 'isDataWarehouseEnable'
};
